"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var connected_react_router_1 = require("connected-react-router");
var react_paginate_1 = __importDefault(require("react-paginate"));
var selectors_1 = require("../selectors");
var createPathByFilters_1 = __importDefault(require("../utils/createPathByFilters"));
var track_event_1 = __importDefault(require("../../../utils/track-event"));
var selectors_2 = require("../../common/selectors");
var atoms_1 = require("../../styles/atoms");
var GenericButton_1 = __importDefault(require("../../common/GenericButton"));
var styled_components_1 = __importDefault(require("styled-components"));
var Pagination = function () {
    var isCustomStore = (0, react_redux_1.useSelector)(selectors_2.isCustomStoreSelector);
    var dispatch = (0, react_redux_1.useDispatch)();
    var filters = (0, selectors_1.useFiltersSelector)(isCustomStore);
    var pagination = (0, react_redux_1.useSelector)(selectors_1.paginationSelector);
    var _a = (0, react_1.useState)(true), isFirstForcingPage = _a[0], setIsFirstForcingPage = _a[1];
    var handlePageChange = function (_a) {
        var selected = _a.selected;
        if (isFirstForcingPage) {
            setIsFirstForcingPage(false);
            return;
        }
        var page = selected + 1;
        var url = (0, createPathByFilters_1.default)(filters, {
            page: page,
        });
        dispatch((0, connected_react_router_1.push)(url));
        if (page !== filters.page) {
            (0, track_event_1.default)({
                category: 'store button',
                action: 'Switch listing page',
                label: String(page),
            });
        }
    };
    var hrefBuilder = function (page) {
        if (page === filters.page)
            return '';
        return (0, createPathByFilters_1.default)(filters, {
            page: page,
        });
    };
    var loadMoreProducts = function (e) {
        var url = e.target.dataset.href || '';
        dispatch((0, connected_react_router_1.push)(url, {
            addProducts: true,
        }));
        (0, track_event_1.default)({
            category: 'store button',
            action: 'Button load more click',
        });
    };
    var nextPage = (0, createPathByFilters_1.default)(filters, {
        page: +filters.page + 1,
    });
    return pagination.pageCount ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(atoms_1.Div, { visible: pagination.pageCount !== filters.page },
            react_1.default.createElement(StyledGenericButton, { "data-href": nextPage, onClick: loadMoreProducts }, "\u0415\u0449\u0435 \u043F\u0440\u0438\u043D\u0442\u044B")),
        react_1.default.createElement(react_paginate_1.default, { previousLabel: '', nextLabel: '', initialPage: +filters.page - 1, forcePage: +filters.page - 1, breakLabel: react_1.default.createElement("a", null, "..."), breakClassName: 'break-me', pageCount: pagination.pageCount, marginPagesDisplayed: 2, pageRangeDisplayed: 5, onPageChange: handlePageChange, containerClassName: 'b-pagination', 
            // @ts-ignore
            subContainerClassName: 'pages pagination', activeClassName: 'active', hrefBuilder: hrefBuilder }))) : null;
};
var StyledGenericButton = (0, styled_components_1.default)(GenericButton_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 24px;\n"], ["\n  margin-top: 24px;\n"])));
exports.default = Pagination;
var templateObject_1;
